import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['Measurement'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postMeasurementGetSelected: build.query<PostMeasurementGetSelectedApiResponse, PostMeasurementGetSelectedApiArg>({
        query: (queryArg) => ({
          url: `/Measurement/get-selected`,
          method: 'POST',
          body: queryArg.body,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            measurementDeviceTechnicalName: queryArg.measurementDeviceTechnicalName,
            tsoId: queryArg.tsoId,
            aggregationInterval: queryArg.aggregationInterval,
          },
        }),
        providesTags: ['Measurement'],
      }),
      postMeasurementGetCsvExport: build.query<
        PostMeasurementGetCsvExportApiResponse,
        PostMeasurementGetCsvExportApiArg
      >({
        query: (queryArg) => ({
          url: `/Measurement/get-csv-export`,
          method: 'POST',
          body: queryArg.body,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            measurementDeviceTechnicalName: queryArg.measurementDeviceTechnicalName,
            tsoId: queryArg.tsoId,
            aggregationInterval: queryArg.aggregationInterval,
          },
        }),
        providesTags: ['Measurement'],
      }),
      postMeasurementGetZipExport: build.query<
        PostMeasurementGetZipExportApiResponse,
        PostMeasurementGetZipExportApiArg
      >({
        query: (queryArg) => ({
          url: `/Measurement/get-zip-export`,
          method: 'POST',
          body: queryArg.apiControllersZipExportParameters,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            tsoId: queryArg.tsoId,
            aggregationInterval: queryArg.aggregationInterval,
          },
        }),
        providesTags: ['Measurement'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as measurementApi };
export type PostMeasurementGetSelectedApiResponse = unknown;
export type PostMeasurementGetSelectedApiArg = {
  /** Start time for the requested data */
  from?: string;
  /** End time for the requested data */
  to?: string;
  /** Name of the device for which the data should be retrieved */
  measurementDeviceTechnicalName?: string;
  tsoId?: number;
  aggregationInterval?: string;
  body: string[];
};
export type PostMeasurementGetCsvExportApiResponse = unknown;
export type PostMeasurementGetCsvExportApiArg = {
  /** Start time for the requested data */
  from?: string;
  /** End time for the requested data */
  to?: string;
  /** Name of the device for which the data should be retrieved */
  measurementDeviceTechnicalName?: string;
  tsoId?: number;
  aggregationInterval?: string;
  body: string[];
};
export type PostMeasurementGetZipExportApiResponse = unknown;
export type PostMeasurementGetZipExportApiArg = {
  /** Start time for the requested data */
  from?: string;
  /** End time for the requested data */
  to?: string;
  tsoId?: number;
  aggregationInterval?: string;
  /** Additional parameters */
  apiControllersZipExportParameters: ApiControllersZipExportParameters;
};
export type ApiControllersZipExportParameters = {
  /** Name of the devices for which the data should be retrieved */
  measurementDeviceTechnicalNames?: string[] | null;
  /** Parameter for which the data should be retrieved */
  selection?: string[] | null;
};
export const {
  usePostMeasurementGetSelectedQuery,
  useLazyPostMeasurementGetSelectedQuery,
  usePostMeasurementGetCsvExportQuery,
  useLazyPostMeasurementGetCsvExportQuery,
  usePostMeasurementGetZipExportQuery,
  useLazyPostMeasurementGetZipExportQuery,
} = injectedRtkApi;
